import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConfirmEmailMessages as messages } from './confirmEmailLink.i18n';

export class ConfirmEmailLink extends React.Component {
  constructor() {
    super();
    this.state = {
      alreadyClicked: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ alreadyClicked: true });
    this.props.onClickMethod();
  }

  render() {
    return (
      this.state.alreadyClicked === false ?
          <a style={ { cursor: 'pointer' } }
            onClick={this.handleClick}
            role="link"
            tabIndex="0"
          >
            <FormattedMessage {...messages.labels.resend} />
          </a> :
          <span>
            <FormattedMessage {...messages.labels.resend} />
            <span className="fa fa-spinner fa-spin"></span>
          </span>
    );
  }
}

ConfirmEmailLink.propTypes = {
  onClickMethod: PropTypes.func.isRequired,
};
